import styled, { css } from 'styled-components';
import DataTable from '@components/DataTable';
import { media } from '@simplywallst/ui-core';

export const TooltipName = styled('span')`
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  width: fit-content;
`;

export const TipContainer = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;

export const PeerDataTable = styled(DataTable)`
  table-layout: fixed;
  width: 100%;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};

  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
  }

  tr {
    ${({ theme }) => theme.typography.xSmall};
    height: ${({ theme }) => theme.x4spacePx}px;
  }

  th,
  td {
    padding: ${({ theme }) => theme.x1spacePx}px 12px;
    width: 23%;
    &:first-child {
      width: 31%;
    }
    &:last-child {
      text-align: left;
    }
  }
  caption {
    text-align: left;
  }
`;

export const PeerAverageRow = styled('tr')`
  &&& {
    background: ${({ theme }) => theme.color.chart04RGBA(0.1)};
  }
`;

export const PeerAverageTitle = styled('td')`
  color: ${({ theme }) => theme.color.chart04};
`;

interface SelectableProps {
  selected?: boolean;
}
export const CompanyNameCell = styled('div')<SelectableProps>`
  width: 100%;
  height: 100%;
  display: flex;
  text-decoration: none;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  ${media.smDown`
  flex-direction: column;
  `}
`;

export const TableSymbol = styled('a')<SelectableProps>`
  color: ${({ theme }) => theme.color.brand01};
  text-decoration: none;
  margin-right: 0.25em;
`;

export const TableSpan = styled('span')<SelectableProps>`
  ${({ selected, theme }) => selected && `color: ${theme.color.brand01};`}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const TableCell = styled('td')<SelectableProps>`
  ${({ selected, theme }) => selected && `color: ${theme.color.white};`}

  &&& {
    vertical-align: middle;
  }
`;

export const TableRow = styled('tr')<SelectableProps>`
  position: relative;
  &&& {
    ${({ selected, theme }) =>
      selected && `background: ${theme.color.brand01RGBA(0.1)};`}
    ${({ selected }) => !selected && `cursor: pointer;`}

    &:hover {
      ${({ selected, theme }) =>
        !selected && `background: ${theme.color.whiteRGBA(0.05)};`}
    }
  }

  ${({ selected, theme }) =>
    selected &&
    css`
      &::after {
        content: ' ';
        display: block;
        position: absolute;
        width: 4px;
        background-color: ${theme.color.brand01};
        left: 0;
        top: 0;
        bottom: 0;
      }
    `}
`;
